import ImageContainer from './ImageContainer'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

const FullWidthImageContainer = ({
  imageUrl,
  title,
  special,
  button,
  titleClassName = 'border-t-b',
  description,
  descriptionURL = null,
}) => {
  let Description
  if (description && descriptionURL) {
    Description = (
      <Link className="no-style-link" to={descriptionURL}>
        <h4>{description}</h4>
      </Link>
    )
  } else if (description) {
    Description = <h4>{description}</h4>
  }

  return (
    <ImageContainer imageUrl={imageUrl}>
      <div className="image-details has-text-white has-text-centered">
        {title && (
          <h1 className={titleClassName + ' title has-text-white'}>{title}</h1>
        )}

        {special && <h4 className="is-size-4 border-b-c">{special}</h4>}

        {Description}

        {button && button()}
      </div>
    </ImageContainer>
  )
}

FullWidthImageContainer.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  button: PropTypes.func,
}

export default FullWidthImageContainer
